import { render } from "./UploadButtons.vue?vue&type=template&id=1a21e34a&scoped=true&ts=true"
import script from "./UploadButtons.vue?vue&type=script&lang=ts"
export * from "./UploadButtons.vue?vue&type=script&lang=ts"

import "./UploadButtons.vue?vue&type=style&index=0&id=1a21e34a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src835202786/src/web-previewer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a21e34a"]])

export default __exports__